// extracted by mini-css-extract-plugin
module.exports = {"embedContainer":"FloridaGatorsVideo_embedContainer__kXn3Z","embed":"FloridaGatorsVideo_embed__VBqDq"};